import React from 'react';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section 
      className="hero-section"
      style={{
        backgroundImage: `url('/Photos/Trucks image.png')`
      }}
    >
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            <span className="hero-title-gsps">GSPS</span>{' '}
            <span className="hero-title-rest">TRADING CORPORATION</span>
          </h1>
          <p className="hero-description">Our goodwill is built on consistent quality, wide product availability, and reliable delivery.</p>
          <div className="hero-points">
            <div className="hero-point">
              <div className="tick-mark">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <span>Powering India's Heavy Commercial Vehicle Ecosystem.</span>
            </div>
            <div className="hero-point">
              <div className="tick-mark">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <span>Built for Heavy Duty, Delivered with Precision.</span>
            </div>
          </div>
          <a href="#contact" className="hero-cta">Partner With Us</a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;

